var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/calendar-arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33333 12.0007L12 9.33398M12 9.33398L14.6667 12.0007M12 9.33398V14.6673M10.6667 1.33398V4.00065M14 7.56265V4.00065C14 3.64703 13.8595 3.30789 13.6095 3.05784C13.3594 2.80779 13.0203 2.66732 12.6667 2.66732H3.33333C2.97971 2.66732 2.64057 2.80779 2.39052 3.05784C2.14048 3.30789 2 3.64703 2 4.00065V13.334C2 13.6876 2.14048 14.0267 2.39052 14.2768C2.64057 14.5268 2.97971 14.6673 3.33333 14.6673H9.33333M2 6.66732H14M5.33333 1.33398V4.00065",
    stroke: "#2D3958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarArrowUp);
export default __webpack_public_path__ + "static/media/calendar-arrow-up.0689e0a44ad658a2225753344dc87d37.svg";
export { ForwardRef as ReactComponent };